export const ProjectBillingStatusDetail = {
  ReadyForInvoiceGeneration: 0,
  InAnotherBillingForGivenPeriod: 1,
  OtherBillingReferenceRemoved: 2,
  InvoiceGenerated: 3,
  InvoiceFinalized: 4
};

export const BillingCustomerDetailStatus = {
  ReadyForInvoiceGeneration: 10,
  QueuedForInvoiceGeneration: 20,
  InvoiceGenerationFailure: 30,
  InvoiceGenerated: 40,
  QueuedForAbort: 50,
  QueuedForFinalization: 60,
  FinalizedPartially: 70,
  FinalizedCompletely: 80,
  InAnotherBillingForGivenPeriod: 90,
  QueuedForInvoiceRegeneration: 100,
  InvoiceRegenerated: 110,
  InvoiceRegenerationFailure: 120
};
